export function syncDocumentLanguage(locale: string): void {
  const htmlLang = locale === 'el' ? 'el' : 'en';

  document.documentElement.lang = htmlLang;
  document.documentElement.setAttribute('translate', 'no');
  document.documentElement.classList.add('notranslate');
}
